const respondMixin = {
  data: function() {
    return {
      screenType: this.getScreen(),
    };
  },
  methods: {
    getScreen: function() {
      if (window.innerWidth <= 600) return "phone";
      else if (window.innerWidth <= 900) return "tab-port";
      else if (window.innerWidth <= 1200) return "tab-land";
      else if (window.innerWidth >= 1800) return "big-desk";
      else return "default";
    },
  },
  created: function() {
    window.addEventListener("resize", () => {
      this.screenType = this.getScreen();
    });
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", () => {
      this.screenType = this.getScreen();
    });
  },
};

const dateMixin = {
  computed: {
    year: function() {
      const date = new Date();
      return date.getFullYear();
    },
  },
};

export { respondMixin, dateMixin };
